import * as React from 'react';
import { useState, useEffect, useRef } from "react";
import { useCombinedRefs } from '../../hooks';
import { CHEVRON_DOWN_SVG } from '../../assets';
var minSubMenuHeight = 200;
function contains(rect, x, y, yOffset) {
    if (yOffset === void 0) { yOffset = 0; }
    if (!rect) {
        return false;
    }
    return rect.x <= x && x <= rect.x + rect.width &&
        (rect.y - yOffset) <= y && y <= (rect.y + yOffset) + rect.height;
}
function cumulativeOffset(element) {
    var top = 0, left = 0;
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while (element);
    return {
        top: top,
        left: left
    };
}
;
var DropdownButton = React.forwardRef(function (props, ref) {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(props.open || false), menuExpanded = _b[0], setMenuExpanded = _b[1];
    var buttonMenuRef = useRef(null);
    var innerRef = useCombinedRefs(ref, buttonMenuRef);
    var menuItems = useRef(null);
    var _c = useState(), lastLi = _c[0], setLastLi = _c[1];
    useEffect(function () {
        loadingState();
        document.body.addEventListener("click", function (e) {
            closeDropDown(e);
        });
    }, []);
    useEffect(function () {
        setMenuExpanded(props.open);
    }, [props.open]);
    useEffect(function () {
        props.onOpen && props.onOpen(menuExpanded);
    }, [menuExpanded]);
    var loadingState = function () {
        if (props.loading)
            setLoading(true);
        else
            setLoading(false);
    };
    var setMenu = function () {
        if (props.open !== undefined) {
            return;
        }
        if (menuExpanded) {
            setMenuExpanded(false);
        }
        else
            setMenuExpanded(true);
    };
    var setMenuMouseLeave = function (e) {
        var _a;
        if (!menuExpanded) {
            return;
        }
        var bounds1 = buttonMenuRef.current.getBoundingClientRect();
        var bounds2 = (_a = menuItems.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!contains(bounds1, e.clientX, e.clientY) && !contains(bounds2, e.clientX, e.clientY, 40)) {
            setMenu();
        }
    };
    var handleButtonClick = function () {
        setMenu();
        if (props.onClick) {
            var res = props.onClick();
            if (res != undefined && 'finally' in res) {
                setLoading(true);
                res.finally(function () {
                    setLoading(false);
                });
            }
        }
    };
    var closeDropDown = function (e) {
        if (props.open !== undefined) {
            return;
        }
        // if click outside JSX collapse menu
        if (!buttonMenuRef.current) {
            return;
        }
        if (!buttonMenuRef.current.contains(e.target)) {
            setMenuExpanded(false);
        }
    };
    var closeDropdownNavClick = function () {
        if (props.open !== undefined) {
            return;
        }
        setMenuExpanded(false);
    };
    var noChevron = props.menuItems && !props.menuItems.some(function (obj) { return obj.subItems; });
    var determineChevron = function (subItems) {
        if (noChevron)
            return 'chevron-down none';
        else if (subItems && subItems.length > 0) {
            if (subItems.find(function (s) { return s.selected; })) {
                return 'chevron-down colored';
            }
            return 'chevron-down';
        }
        else
            return 'chevron-down hidden';
    };
    var renderImage = function (menuImage, menuImageWidth) {
        if (menuImage) {
            return (React.createElement("div", { className: "menu-img-container" },
                React.createElement("img", { className: "menu-items-img", src: menuImage, width: menuImageWidth || "13", alt: "icon" })));
        }
        return null;
    };
    var maxHeightNav = Math.min(window.innerHeight - (innerRef.current ? (cumulativeOffset(innerRef.current).top - document.scrollingElement.scrollTop) : 400), window.innerHeight);
    maxHeightNav -= 10;
    var maxHeightSubMenu = Math.min(window.innerHeight - (lastLi ? (cumulativeOffset(lastLi).top - document.scrollingElement.scrollTop) : 400), window.innerHeight);
    maxHeightSubMenu -= 10;
    var topSubMenu = -20;
    if (maxHeightSubMenu < minSubMenuHeight) {
        topSubMenu = ((minSubMenuHeight + 20) - maxHeightSubMenu) * -1;
        maxHeightSubMenu = minSubMenuHeight;
    }
    return (React.createElement("div", { className: 'DropdownButton ' + (props.className || '') + ' ' + (menuExpanded ? 'open' : ''), ref: innerRef, onMouseEnter: props.hover && !menuExpanded ? setMenu : undefined, onMouseOut: props.hover ? setMenuMouseLeave : undefined },
        React.createElement("button", { style: { width: props.width ? props.width : '' }, onClick: function () {
                handleButtonClick();
            }, disabled: props.disabled },
            renderImage(props.buttonImageLeft, props.buttonImageWidth),
            React.createElement("span", null, loading ? "loading..." : props.buttonText),
            renderImage(props.buttonImageRight, props.buttonImageWidth)),
        props.menuItems && props.menuItems.length > 0 &&
            React.createElement("nav", { className: (menuExpanded ? "slide-down" : "slide-up") + (maxHeightNav < minSubMenuHeight ? ' up' : ''), onClick: function () {
                    closeDropdownNavClick();
                } },
                React.createElement("ul", { className: 'menu-items', ref: menuItems, onMouseOut: props.hover ? setMenuMouseLeave : undefined }, props.menuItems.map(function (item, index) {
                    return (React.createElement("li", { className: "list-item " + (item.selected ? 'selected' : '') + " " + (noChevron ? 'no-chev' : ''), key: index, onMouseOver: function (e) {
                            setLastLi(e.currentTarget);
                        }, onClick: item.onClick },
                        renderImage(item.menuImage, item.menuImageWidth),
                        React.createElement("span", { className: "menu-items-text " + (noChevron ? 'no-chev' : ''), style: item.menuImage ? { marginLeft: '0' } : { marginLeft: '3rem' } }, item.text),
                        React.createElement("img", { className: determineChevron(item.subItems), width: "10", src: CHEVRON_DOWN_SVG, alt: "chevron down" }),
                        item.subItems && item.subItems.length > 0 ?
                            React.createElement("ul", { className: "subitems-container", style: menuItems.current ? {
                                    left: menuItems.current.clientWidth,
                                    maxHeight: maxHeightSubMenu,
                                    top: topSubMenu + 2
                                } : undefined }, item.subItems.map(function (item, index) {
                                return (React.createElement("li", { className: "sublist-item " + (item.selected ? 'selected' : ''), key: index, onClick: function (e) {
                                        if (item.onClick) {
                                            e.stopPropagation();
                                            item.onClick();
                                            setMenu();
                                        }
                                    } },
                                    renderImage(item.menuImage, item.menuImageWidth),
                                    React.createElement("span", null, item.text)));
                            }))
                            : null));
                })))));
});
export default DropdownButton;
//# sourceMappingURL=DropdownButton.js.map